import { normalize, schema } from 'normalizr';

const team = new schema.Entity(
    'teams',
    {},
    { idAttribute: 'teamId' }
);

const playerDetail = new schema.Entity(
    'players',
    {},
    { idAttribute: ( _value, parent ) => parent.playerId }
);

const stat = new schema.Entity(
    'stats',
    {
        playerDetails: playerDetail,
        team: team,
    },
    {
        idAttribute: ( value, parent ) => {
            return value.playerId + '_' + parent.search.context.identifier;
        }
    }
);

/**
 * @param {object} apiData - API response body.
 * @returns {object} The normalized response.
 */
export const normalizeStatsLeaders = apiData => {
    return normalize(
        apiData,
        { players: [ stat ] }
    );
};